module.exports = __webpack_public_path__ + "static/media/SANJEEVINI-NIDHI-Charity.3f1da215.pdf";